const BOOKINGS_BASE = '/agent/bookings';

export const ENDPOINTS = {
  ADMIN_AUTH: {
    LOGIN: '/admin/auth/login',
    LOGOUT: '/admin/auth/logout',
    ME: '/admin/auth/me',
    REFRESH: '/admin/auth/refresh',
    SET_PASSWORD: '/admin/auth/set-password',
    FORGOT_PASSWORD: '/admin/auth/forgot-password',
    RESET_PASSWORD: '/admin/auth/reset-password',
    UPDATE_PROFILE: '/admin/auth/profile',
  },
  AGENT: {
    AGENT: '/agent',
    REGISTER: '/agent/register',
    GET_ALL: '/agent/all',
    GET_BY_ID: (id: number) => `/agent/${id}`,
    UPDATE: (id: number) => `/agent/update/${id}`,
    LOGIN: '/agent/login',
  },
  OPERATORS: {
    GET_ALL: '/agent/operators',
    GET_BY_ID: (id: number) => `/agent/operators/${id}`,
    CREATE: '/agent/operators',
    UPDATE: (id: number) => `/agent/operators/${id}/update`,
    DEACTIVATE: (id: number) => `/agent/operators/${id}/deactivate`,
    REACTIVATE: (id: number) => `/agent/operators/${id}/reactivate`,
    RESEND_INVITATION: (id: number) =>
      `/agent/operators/${id}/resend-invitation`,
    TASKS: (id: number) => `/agent/operators/${id}/tasks`,
  },
  ADMIN_USERS: {
    GET_ALL: '/admin-users',
    GET_BY_ID: (id: number) => `/admin-users/${id}`,
    CREATE: '/admin-users',
    UPDATE: (id: number) => `/admin-users/${id}`,
    DELETE: (id: number) => `/admin-users/${id}`,
    DEACTIVATE: (id: number) => `/admin-users/${id}/deactivate`,
    REACTIVATE: (id: number) => `/admin-users/${id}/reactivate`,
    RESEND_INVITATION: (id: number) => `/admin-users/${id}/resend-invitation`,
    SALIS_USERS: '/admin/users/salis-users',
    SALIS_USER_BY_ID: (id: number) => `/admin/users/salis-users/${id}`,
    UPDATE_SALIS_USER_STATUS: (id: number) =>
      `/admin/users/salis-users/${id}/status`,
    SALIS_USER_FEEDBACKS: (id: number) =>
      `/admin/users/salis-users/${id}/feedbacks`,
    CONTACTS: '/admin/users/contacts',
    CONTACT_BY_ID: (id: number) => `/admin/users/contacts/${id}`,
    UPDATE_CONTACT: (id: number) => `/admin/users/contacts/${id}`,
    DELETE_CONTACT: (id: number) => `/admin/users/contacts/${id}`,
  },
  ADMIN_PRODUCTS: {
    GET_ALL: '/admin/products',
    GET_BY_ID: (id: number) => `/admin/products/${id}`,
    UPDATE: (id: number) => `/admin/products/${id}`,
    DELETE_BY_ID: (id: number) => `/admin/products/${id}`,
    UPDATE_STATUS: (id: number) => `/admin/products/${id}/status`,
    TOGGLE_FEATURED: (id: number) => `/admin/products/${id}/toggle-featured`,
    BULK_UPDATE_STATUS: '/admin/products/bulk-update-status',
    STATISTICS: '/admin/products/statistics',
    BY_CATEGORY: '/admin/products/by-category',
    TOP_PERFORMING: '/admin/products/top-performing',
    STATS: (id: number) => `/admin/products/${id}/stats`,
  },
  ADMIN_BOOKINGS: {
    GET_ALL: '/admin/bookings',
    GET_BY_ID: (id: number) => `/admin/bookings/${id}`,
    STATISTICS: '/admin/bookings/statistics',
    UPDATE_STATUS: (id: number) => `/admin/bookings/${id}/status`,
  },
  ADMIN_AGENTS: {
    GET_ALL: '/admin/agents',
    GET_ADMINS: '/admin/agents/accounts',
    GET_BY_ID: (id: number) => `/admin/agents/${id}`,
    EDIT: (id: number) => `/admin/agents/${id}/edit`,
    DELETE: (id: number) => `/admin/agents/${id}`,
    GET_LOGS: (id: number) => `/admin/agents/${id}/logs`,
    STATISTICS: '/admin/agents/statistics',
    GET_ADMIN_DETAILS: (id: number) => `/admin/agents/accounts/${id}`,
    EDIT_ADMIN: (id: number) => `/admin/agents/accounts/${id}/edit`,
    FORGOT_PASSWORD_ADMIN: '/admin/agents/accounts/forgot-password',
    DEACTIVATE_ADMIN: (id: number) => `/admin/agents/accounts/${id}/deactivate`,
    REACTIVATE_ADMIN: (id: number) => `/admin/agents/accounts/${id}/reactivate`,
    GET_ADMIN_LOGS: (id: number) => `/admin/agents/accounts/${id}/logs`,
  },
  ADMIN_CONTRACTS: {
    GET_ALL: '/admin/contracts',
    GET_BY_ID: (id: number) => `/admin/contracts/${id}`,
    GET_PDF: (id: number) => `/admin/contracts/${id}/pdf`,
  },
  ADMIN_DASHBOARD: {
    OVERVIEW: '/admin/dashboard',
    TOP_AGENTS: '/admin/dashboard/top-agents',
    TOP_MEMBERS: '/admin/dashboard/top-members',
    BOOKINGS: '/admin/dashboard/bookings',
    CATEGORIES: '/admin/dashboard/categories',
  },
  ADMIN_OPERATORS: {
    GET_ALL: '/admin/operators',
    GET_BY_ID: (id: number) => `/admin/operators/${id}`,
    UPDATE: (id: number) => `/admin/operators/${id}/edit`,
    FORGOT_PASSWORD: '/admin/operators/forgot-password',
    DEACTIVATE: (id: number) => `/admin/operators/${id}/deactivate`,
    REACTIVATE: (id: number) => `/admin/operators/${id}/reactivate`,
    TASKS: (id: number) => `/admin/operators/${id}/tasks`,
    TIMELINE: (id: number) => `/admin/operators/${id}/timeline`,
  },
  ADMIN_ATTRIBUTES: {
    GET_ATTRIBUTE_OPTIONS: '/admin/attributes/options',
    GET_PARENT_OPTIONS: '/admin/attributes/parent-options',
    CREATE_ATTRIBUTE_OPTION: '/admin/attributes/options',
    UPDATE_ATTRIBUTE_OPTION: (id: number) => `/admin/attributes/options/${id}`,
    DELETE_ATTRIBUTE_OPTION: (id: number) => `/admin/attributes/options/${id}`,
    GET_CATEGORY_ATTRIBUTES: '/attributes/category-attributes',
  },
  ADMIN_CHARGE_TYPES: {
    GET_ALL: '/admin/charge-types',
    CREATE: '/admin/charge-types',
    UPDATE: (id: number) => `/admin/charge-types/${id}`,
    DELETE: (id: number) => `/admin/charge-types/${id}`,
  },
  ADMIN_FEEDBACKS: {
    GET_ALL: '/admin/feedbacks',
    GET_BY_ID: (id: number) => `/admin/feedbacks/${id}`,
    STATISTICS: '/admin/feedbacks/stats',
    MARK_AS_REVIEWED: '/admin/feedbacks/mark-as-reviewed',
    TOGGLE_VISIBILITY: '/admin/feedbacks/toggle-visibility',
  },
  ADMIN_NOTIFICATIONS: {
    GET_ALL: '/admin/notifications',
    STATISTICS: '/admin/notifications/stats',
    MARK_AS_READ: (id: number) => `/admin/notifications/${id}/mark-as-read`,
    MARK_MULTIPLE_AS_READ: '/admin/notifications/mark-multiple-as-read',
    MARK_ALL_AS_READ: '/admin/notifications/mark-all-as-read',
    CREATE_SAMPLES: '/admin/notifications/create-samples',
  },
  ADMIN_ACTIVITIES: {
    GET_ALL: '/admin/logs',
    GET_BY_AGENT: (agentId: number) => `/admin/logs?agent_id=${agentId}`,
  },
  PRODUCTS: {
    GET_ALL: '/agent/products',
    GET_BY_ID: (id: number) => `/agent/products/${id}`,
    DELETE_BY_ID: (id: number) => `/agent/products/${id}`,
    CREATE: '/products/create',
    UPDATE: (id: number) => `/agent/products/${id}/update`,
    DELETE: (id: number) => `/products/delete/${id}`,
    DYNAMIC_FORMS: '/dynamic-forms',
    ATTRIBUTES: '/attributes',
    OPTIONS: '/options',
    CALENDAR: (id: number) => `/agent/products/${id}/calendar`,
    MARK_DATES_AS_UNAVAILABLE: (id: number) =>
      `/agent/products/${id}/unavailable-dates`,
    STATS: (id: number) => `/agent/products/${id}/stats`,
  },
  CATEGORIES: {
    GET_ALL: '/categories',
    GET_BY_ID: (id: number) => `/categories/${id}`,
  },
  ORDERS: {
    GET_ALL: '/orders',
    GET_BY_ID: (id: number) => `/orders/${id}`,
  },
  BOOKINGS: {
    GET_ALL: BOOKINGS_BASE,
    SEARCH_USERS: `${BOOKINGS_BASE}/users`,
    VALIDATE: `${BOOKINGS_BASE}/validate`,
    CREATE_MANUAL: `${BOOKINGS_BASE}/manual`,
    GET_BY_ID: (id: number) => `/bookings/${id}`,
    CREATE: '/bookings/create',
    RESPOND: (id: number) => `${BOOKINGS_BASE}/${id}/status`,
    ASSIGN_OPERATOR: (id: number) => `${BOOKINGS_BASE}/${id}/assign-operator`,
    AVAILABLE_TASKS: (id: number) => `${BOOKINGS_BASE}/${id}/available-tasks`,
    CATEGORY_TASKS: (categoryId: number) =>
      `${BOOKINGS_BASE}/categories/${categoryId}/tasks`,
    UPLOAD_PRIVATE_CONTACT_DOCUMENT: (privateContactId: number) =>
      `${BOOKINGS_BASE}/private-contact/${privateContactId}/documents`,
    STATS: `${BOOKINGS_BASE}/stats`,
  },
  PROMOTIONS: {
    GET_ALL: '/agent/promotions',
    CREATE: '/agent/promotions/create',
    PRODUCTS: '/agent/promotions/products',
    PRODUCT_DETAILS: (id: number) => `/agent/promotions/products/${id}`,
  },
  ADMIN_PROMOTIONS: {
    GET_ALL: '/admin/promotions',
    GET_BY_ID: (id: number) => `/admin/promotions/${id}`,
    UPDATE: (id: number) => `/admin/promotions/${id}`,
    UPDATE_STATUS: (id: number) => `/admin/promotions/${id}/status`,
    STATS: '/admin/promotions/stats',
  },
  ADMIN_PROMO_CODES: {
    GET_ALL: '/admin/promo-codes',
    GET_BY_ID: (id: number) => `/admin/promo-codes/${id}`,
    UPDATE: (id: number) => `/admin/promo-codes/${id}`,
    DELETE: (id: number) => `/admin/promo-codes/${id}`,
    UPDATE_STATUS: (id: number) => `/admin/promo-codes/${id}/status`,
    STATS: '/admin/promo-codes/stats',
  },
  NOTIFICATIONS: {
    GET_ALL: '/agent/notifications',
    MARK_AS_READ: (id: string) => `/agent/notifications/${id}/mark-as-read`,
    MARK_ALL_AS_READ: '/agent/notifications/mark-all-as-read',
    DELETE: (id: string) => `/agent/notifications/${id}`,
    UNREAD_COUNT: '/agent/notifications/unread-count',
  },
  DASHBOARD: {
    STATISTICS: '/agent/dashboard/statistics',
  },
  LOOKUPS: {
    COUNTRIES: '/lookups/countries',
    CITIES: (countryId: number) => `/lookups/cities/${countryId}`,
    CATEGORIES: '/lookups/categories',
  },
  CONTACTS: {
    CREATE: '/agent/contacts',
    GET_ALL: '/agent/contacts',
  },
  OPERATOR_AUTH: {
    LOGIN: '/operator/auth/login',
    LOGOUT: '/operator/auth/logout',
    COMPLETE_REGISTRATION: (token: string) =>
      `/operator/complete-registration/${token}`,
  },
  OPERATOR: {
    MY_TASKS: '/operator/my-tasks',
    PROFILE: '/operator/profile',
    UPDATE_TASK_STATUS: (assignmentId: number) =>
      `/operator/tasks/${assignmentId}/status`,
  },
  ADMIN_CURRENCIES: {
    GET_ALL: '/admin/currencies',
    UPDATE: '/admin/currencies',
    GET_BASE: '/admin/currencies/base',
    GET_ACTIVE: '/admin/currencies/active',
  },
  ADMIN_PUSH_NOTIFICATIONS: {
    HISTORY: '/admin/push-notifications/history',
    STATS: '/admin/push-notifications/history/stats',
    SEARCH_RECIPIENTS: '/admin/push-notifications/search-recipients',
    PREVIEW: '/admin/push-notifications/preview',
    SEND: '/admin/push-notifications/send',
  },
  ADMIN_ADMINS: {
    GET_ALL: '/admin/admins',
    CREATE: '/admin/admins',
    GET_BY_ID: (id: number) => `/admin/admins/${id}`,
    UPDATE: (id: number) => `/admin/admins/${id}`,
    DELETE: (id: number) => `/admin/admins/${id}`,
    CHANGE_STATUS: (id: number) => `/admin/admins/${id}/status`,
    RESEND_INVITATION: (id: number) => `/admin/admins/${id}/resend-invitation`,
    FORGOT_PASSWORD: '/admin/admins/forgot-password',
    SET_PASSWORD: '/admin/set-password',
    GET_PERMISSIONS: '/admin/admins/permissions',
    GET_LOGS: (id: number) => `/admin/admins/${id}/logs`,
  },
};
